export const fonts = `"Noto Sans JP", sans-serif`;

export const typography = {
  allVariants: {
    fontFamily: fonts,
    fontStyle: "normal",
  },
  // headline
  head32Bold: {
    fontSize: "32px",
    lineHeight: "38px",
    fontWeight: 700,
  },
  head24Semi: {
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 500,
  },
  head24Bold: {
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 700,
  },
  head20Semi: {
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: 500,
  },
  head20Light: {
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: 200,
  },
  head24Light: {
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 100,
  },
  head20Bold: {
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: 700,
  },
  sub16Light: {
    fontSize: "16px",
    lineHeight: "27px",
    fontWeight: 200,
  },
  // subtitle
  sub16Bold: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
  },
  sub16Semi: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 500,
  },
  // body
  body14Bold: {
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 700,
  },
  body14: {
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 400,
  },
  body14Light: {
    fontSize: "14px",
    lineHeight: "22px",
    fontWeight: 200,
  },
  body14Semi: {
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: 500,
  },
  // caption
  cap8Light: {
    fontSize: "8px",
    lineHeight: "14px",
    fontWeight: 200,
  },
  cap10Light: {
    fontSize: "10px",
    lineHeight: "20px",
    fontWeight: 200,
  },
  cap11Light: {
    fontSize: "11px",
    lineHeight: "21px",
    fontWeight: 200,
  },
  cap12Light: {
    fontSize: "12px",
    lineHeight: "23px",
    fontWeight: 200,
  },
  cap12Bold: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 700,
  },
  cap12: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
  },
  cap13Light: {
    fontSize: "13px",
    lineHeight: "23px",
    fontWeight: 200,
  },
  // link
  link14Semi: {
    fontSize: "14px",
    lineHeight: "22.4px",
    fontWeight: 500,
    textDecoration: "underline",
  },
} as const;

declare module "@mui/material/styles" {
  interface TypographyVariants {
    // headline
    head32Bold: React.CSSProperties;
    head24Semi: React.CSSProperties;
    head24Bold: React.CSSProperties;
    head20Semi: React.CSSProperties;
    head20Light: React.CSSProperties;
    head20Bold: React.CSSProperties;
    head24Light: React.CSSProperties;
    // subtitle
    sub16Light: React.CSSProperties;
    sub16Bold: React.CSSProperties;
    sub16Semi: React.CSSProperties;
    // body
    body14Bold: React.CSSProperties;
    body14: React.CSSProperties;
    body14Light: React.CSSProperties;
    body14Semi: React.CSSProperties;
    // caption
    cap8Light: React.CSSProperties;
    cap10Light: React.CSSProperties;
    cap12Light: React.CSSProperties;
    cap12Bold: React.CSSProperties;
    cap12: React.CSSProperties;
    cap13Light: React.CSSProperties;
    // link
    link14Semi: React.CSSProperties;
  }

  // Update the Typography's variant prop options
  interface TypographyVariantsOptions {
    // headline
    head32Bold: React.CSSProperties;
    head24Semi: React.CSSProperties;
    head24Bold: React.CSSProperties;
    head20Semi: React.CSSProperties;
    head20Light: React.CSSProperties;
    head20Bold: React.CSSProperties;
    head24Light: React.CSSProperties;
    // subtitle
    sub16Light: React.CSSProperties;
    sub16Bold: React.CSSProperties;
    sub16Semi: React.CSSProperties;
    // body
    body14Bold: React.CSSProperties;
    body14: React.CSSProperties;
    body14Light: React.CSSProperties;
    // caption
    cap8Light: React.CSSProperties;
    cap10Light: React.CSSProperties;
    cap12Light: React.CSSProperties;
    cap12Bold: React.CSSProperties;
    cap12: React.CSSProperties;
    cap13Light: React.CSSProperties;
    // link
    link14Semi: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    // headline
    head32Bold: true;
    head24Semi: true;
    head24Bold: true;
    head20Semi: true;
    head20Light: true;
    head20Bold: true;
    head24Light: true;
    // subtitle
    sub16Light: true;
    sub16Bold: true;
    sub16Semi: true;
    // body
    body14Bold: true;
    body14: true;
    body14Light: true;
    body14Semi: true;
    // caption
    cap8Light: true;
    cap10Light: true;
    cap11Light: true;
    cap12Light: true;
    cap12Bold: true;
    cap12: true;
    cap13Light: true;
    // link
    link14Semi: true;
  }
}
